import Layout from '@/layout/ezpay-index.vue'

export const customerServiceRouter = {
  path: '/customerServiceManage',
  component: Layout,
  // redirect: '/customerServiceManage/list',
  name: 'Customer_Service_Manage',
  meta: { title: 'customerService_manage', icon: 'customer-service' },
  children: [
    {
      path: 'query/pay',
      name: 'Customer_Service_Query_Pay',
      component: () => import('@/views/ezpay/customer-service/query-pay'),
      meta: {
        title: 'customerService_manage_query_pay', noCache: false,
        auth: ['AUTH_CODE_CUSTOMER_SERVICE_PAYIN']
      }
    },
    {
      path: 'query/refund',
      name: 'Customer_Service_Query_Refund',
      component: () => import('@/views/ezpay/customer-service/query-refund'),
      meta: {
        title: 'refund_transaction_query', noCache: false,
        auth: ['AUTH_CODE_REFUND_TRANSACTION_CUSTOMER_SEARCH']
      }
    },
    {
      path: 'query/payout',
      name: 'Customer_Service_Query_Payout',
      component: () => import('@/views/ezpay/customer-service/query-payout'),
      meta: {
        title: 'customerService_manage_query_payout', noCache: false,
        auth: ['AUTH_CODE_CUSTOMER_SERVICE_PAYOUT']
      }
    },
    {
      path: 'ticket',
      name: 'Customer_Service_Ticket_List',
      component: () => import('@/views/ezpay/customer-service/ticket-list'),
      meta: {
        title: 'customer_service_ticket_list', noCache: false,
        auth: ['AUTH_CODE_CUSTOMER_SERVICE']
      }
    }
  ]
}
